import React, { useState, useEffect } from 'react';
import { useAppDispatch } from '../../../stores/app.store.config';
import { setPlan } from '../../../stores/slices/plan.slice';
import { useAuth } from '../../../stores/selectors/auth.selector';
import { usePlansAvailable } from '../../../stores/selectors/plans-available.selector';
import { displayCurrency } from '../../../services/utils/currency.utils';
import config from '../../../../config';
import { Action, triggerActionGTM, category } from '../../../services/optimization/ecommerce.service';
import LinkComponent from '../../link/link.component';
import { usePrismic } from '../../../hooks/prismic.hook';
import { getBuyPageStatus } from '../../../services/api/orders/order.subscriptions.service';
import BuyPageUnavailableModal from './buypage-notice';
import PrismicRichText from '../../../services/prismic/prismic.richtext.service';

const BuyPagePackages = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const email = '';
  const {
    contents: { campaignId, productApi: productsApiDataUnsorted = [] },
  } = usePlansAvailable();

  const [product, setProduct] = useState(Object);
  const [currencyCode, SetCurrencyCode] = useState('');

  const { isAuthenticated, user }: { isAuthenticated: boolean; user: any } = useAuth();

  const [buyPageEnabled, setBuyPageEnabled] = useState(false);
  const [openReminder, setOpenReminder] = useState(false);
  const existingProductId = false;

  const {
    result: { existing_plan_disclaimer, limited_time_offer, mydu_button },
    data: { mydu_enabled, mydu_title, mydu_description, mydu_disclamer, mydu_promotion },
  } = usePrismic('buy_page');

  const lastProduct = productsApiDataUnsorted[4];
  const productsApiData = productsApiDataUnsorted
    .slice(0, 4)
    .sort((a: Record<string, any>, b: Record<string, any>): number => a.price - b.price);

  useEffect(() => {
    if (productsApiData.length) {
      const currencyCode = productsApiData[0].currency;
      const products = productsApiData.map((p: any, index: number) => ({
        name: p.planname,
        id: p.productId,
        price: p.price,
        category,
        position: index + 1,
      }));
      triggerActionGTM(Action.ProductImpression, { currencyCode, products });
    }
  }, [productsApiData]);

  useEffect(() => {
    retrieveBuyPageStatus();
  }, []);

  const retrieveBuyPageStatus = async () => {
    try {
      const data = await getBuyPageStatus();
      setBuyPageEnabled(data);
      if (!data) setOpenReminder(true);
    } catch (error: any) {
      console.log(error);
    }
  };

  if (!productsApiData.length && config.nodeEnv !== 'test') return <div></div>;

  return (
    <div className={'buypageparent'}>
      {openReminder && <BuyPageUnavailableModal setOpenReminder={setOpenReminder} />}
      {isAuthenticated && existingProductId && <h3 style={{ color: 'orange' }}>{existing_plan_disclaimer}</h3>}
      {
        <div className="notice-notlogin">
          <p>{limited_time_offer}</p>
        </div>
      }
      {mydu_enabled && (
        <div className="buypage-mydu">
          <div className="image mydu-image">
            <button className={'limited-offer'}>
              <span>New!</span>
            </button>
          </div>
          <div className="image mydu-logo" />
          <div className="mydu-title">
            <PrismicRichText render={mydu_title} />
          </div>
          <div className="mydu-description">
            <PrismicRichText render={mydu_description} />
          </div>
          {Boolean(mydu_promotion) && (
            <div className="mydu-price before">
              <s>{displayCurrency(lastProduct?.price, lastProduct?.currency)}</s>
            </div>
          )}
          {!Boolean(mydu_promotion) && (
            <div className="mydu-price">{displayCurrency(lastProduct?.price, lastProduct?.currency)}</div>
          )}
          {Boolean(mydu_promotion) && (
            <div className="mydu-price">
              {displayCurrency(lastProduct?.price - lastProduct?.price * mydu_promotion, lastProduct?.currency)}
            </div>
          )}

          <LinkComponent className="btn-wrapper btn-wrapper-myDu" link="/buy/confirm">
            <button
              disabled={!buyPageEnabled || user?.details?.hasMyDUAccess}
              className="theme-button theme-button-mydu"
              onClick={() => {
                const currencyCode = productsApiData[0].currency;
                const product = {
                  name: lastProduct?.planname,
                  id: lastProduct?.productId,
                  price: mydu_promotion ? lastProduct?.price - lastProduct?.price * mydu_promotion : lastProduct?.price,
                  position: 5,
                  category,
                };
                setProduct(product);
                SetCurrencyCode(currencyCode);
                dispatch(
                  setPlan({
                    planName: lastProduct?.planname,
                    planDescription: lastProduct?.plandescription,
                    campaignId,
                    productId: lastProduct?.productId,
                    pricingId: lastProduct?.pricingId,
                    price: mydu_promotion
                      ? lastProduct?.price - lastProduct?.price * mydu_promotion
                      : lastProduct?.price,
                    type: lastProduct?.type,
                    email,
                    currency: lastProduct?.currency,
                    discount: mydu_promotion,
                  }),
                );
              }}
            >
              <div className="theme-button-container">
                <div />
                <span>{mydu_button}</span>
              </div>
            </button>
          </LinkComponent>
          {user?.details?.hasMyDUAccess && (
            <div className="mydu-message">
              <PrismicRichText render={mydu_disclamer} />
            </div>
          )}
          {/* <div className="mydu-disclamer">
            <PrismicRichText render={mydu_disclamer} />
          </div> */}
        </div>
      )}
    </div>
  );
};

export default BuyPagePackages;
